import React from 'react';
import {connect} from 'react-redux';
import MPMBadgesWidget from './Widgets/Badges';

const MPMBadges = props => (
  <div id="mpm-badges">
    <header className="content-header">
      <h1>
        Badges
        <small> MPM</small>
      </h1>
    </header>
    <section className="content">
      <MPMBadgesWidget />
    </section>
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(MPMBadges);



// WEBPACK FOOTER //
// ./src/pages/Other/MPM/Badges/index.tsx